import React from "react";

const DockBottom = ({ style = {} }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 20 16" style={style}>
            <g>
                <g id="dock-bottom">
                    <path
                        id="dock-bottom-2"
                        class="cls-1"
                        d="M18,0H2C.9,0,0,.9,0,2v12c0,1.1.9,2,2,2h16c1.1,0,2-.9,2-2V2c0-1.1-.9-2-2-2M18,9H2V2h16v7Z"
                        fill="#fff" />
                </g>
            </g>
        </svg>
    );
};

export default DockBottom;
